export const curp = value => {
    if (!value || !value.length) {
        return true;
    }

    if (!/^[A-Z]{4}[0-9]{6}[HM][A-Z]{5}[0-9]{2}$/i.test(value)) {
        return 'La CURP no es válida';
    }

    return true;
}

export const email = value => {
    if (!value || !value.length) {
        return true;
    }
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
        return 'El correo no es válido';
    }
    return true;
}

/**
 * Revisa que un valor sea númerico, ya sea entero, o flotante, positivo o negativo
 */
export const numeric = value => {
    if (!value || !value.length) {
        return true;
    }
    if (isNaN(value)) {
        return 'Solo se permiten números';
    }
    return true;
}

export const period = value => {
    if (!value || !value.length) {
        return true;
    }

    // mediante regex se valida el periodo
    if (!/^\d{4}-(1|2)$/.test(value)) {
        return 'No es un período válido. (ej. 2025-1)';
    }

    return true;
}

export const positiveInteger = value => {
    if (!value || !value.length) {
        return true;
    }
    if (isNaN(value) || parseInt(value) < 0) {
        return 'Solo se permiten números positivos';
    }

    if (value % 1 !== 0) {
        return 'Solo se permiten números enteros';
    }

    return true;
}

export const required = value => {
    if (value === null || value === undefined || value === '') {
        return 'Este campo es requerido';
    }
    if (Array.isArray(value) && !value.length) {
        return 'Este campo es requerido';
    }
    if (typeof value === 'string' && !(value.trim().length)) {
        return 'Este campo es requerido';
    }
    return true;
};

/**
 * Revisa que el valor de una cadena tenga cierto número de espacios
 * 
 * @example
 * ```javascript
 * :rules="[$rules.spaces(5)]" // 5 espacios
 * ```
 *
 * @param {number} totalSpaces - El número de espacios que debe tener la cadena
 */
export const spaces = (totalSpaces) => {
    return (value) => {
        if (!value || !value.length) {
            return true;
        }

        const spaceCount = (value.match(/\s/g) || []).length;

        if (spaceCount > totalSpaces) {
            return `La cadena no puede contener más de ${totalSpaces} espacios`;
        }

        if (spaceCount < totalSpaces) {
            return `La cadena debe contener al menos ${totalSpaces} espacios`;
        }

        return true;
    };
};

export const rfc = value => {
    if (!value || !value.length) {
        return true;
    }

    if (value.length != 13) {
        return 'El RFC consta de 13 caracteres';
    }

    if (!/^[0-9a-zA-Z]+$/.test(value)) {
        return "El RFC solo puede contener letras y números";
    }

    if (!/^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/i.test(value)) {
        return 'El RFC no es válido';
    }

    return true;
}

export const text = value => {
    if (!value || !value.length) {
        return true;
    }
    if (!/^[a-zA-ZÀ-ÖØ-öø-ÿ\s]*$/i.test(value)) {
        return 'Solo se permiten letras y espacios';
    }
    return true;
}

export const between = (min, max) => {
    return (value) => {
        if (!value || !value.length) {
            return true;
        }

        if (value < min || value > max) {
            return `El valor debe estar entre ${min} y ${max}`;
        }

        return true;
    };
};

export const min = (min) => {
    return (value) => {
        if (!value || !value.length) {
            return true;
        }

        if (value < min) {
            return `El valor debe ser mayor o igual a ${min}`;
        }

        return true;
    };
};

export const minLength = (min) => {
    return (value) => {
        if (!value || !value.length) {
            return true
        }

        if (value.length < min) {
            return `El valor debe ser mayor o igual a ${min} caracteres`;
        }

        return true;
    };
}

export const max = (max) => {
    return (value) => {
        if (!value || !value.length) {
            return true;
        }

        if (value > max) {
            return `El valor debe ser menor o igual a ${max}`;
        }

        return true;
    };
}

export const maxLength = (max) => {
    return (value) => {
        if (!value || !value.length) {
            return true
        }

        if (value.length > max) {
            return `El valor debe ser menor o igual a ${max} caracteres`;
        }

        return true;
    };
}

export const length = (length) => {
    return (value) => {
        if (!value || !value.length) {
            return true
        }

        if (value.length !== length) {
            return `El valor debe tener ${length} caracteres`;
        }

        return true;
    };
}

export const alphanumeric = value => {
    if (!value || !value.length) {
        return true
    }

    return /^[a-zA-Z0-9]+$/.test(value) || 'Ingresa únicamente números y letras'
}

export const alphabetical = value => {
    if (!value || !value.length) {
        return true
    }

    return /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/.test(value) || 'Ingresa solamente letras';
}

export const greaterOrEqualsThan = (...greaterThan) => {
    return (value) => {
        if (!value || !value.length) {
            return true
        }

        if (!greaterThan || !greaterThan.length) {
            return true;
        }

        if (!Array.isArray(greaterThan)) {
            greaterThan = [greaterThan];
        }

        for (const greaterThanValue of greaterThan) {

            if (value < greaterThanValue) {
                return `El valor debe ser mayor o igual a ${greaterThanValue}`;
            }
        }

        return true;
    };
}

/**
 * @param {number} maxSize - El tamaño maximo del archivo en MB
 */
export const fileSize = (maxSize) => {
    return (value) => {
        if (!value || !value.length) {
            return true
        }

        for (const file of value) {
            if (file.size > maxSize * 1024 * 1024) {
                return `El archivo no debe superar los ${maxSize} MB`;
            }
        }

        return true;
    };
}

export const image = (value) => {

    if (!value || !value.length) {
        return true
    }

    for (const file of value) {
        if (!file.type.includes('image')) {
            return 'El archivo debe ser una imagen';
        }
    }

    return true;
}

export const password = (value) => {
    if (!value || !value.length) {
        return true
    }

    if (value.length < 8) {
        return 'La contraseña debe tener al menos 8 caracteres';
    }

    if (!/[a-z]/.test(value)) {
        return 'La contraseña debe contener al menos una letra minúscula';
    }

    if (!/[A-Z]/.test(value)) {
        return 'La contraseña debe contener al menos una letra mayúscula';
    }

    if (!/[0-9]/.test(value)) {
        return 'La contraseña debe contener al menos un número';
    }

    return true;
}

export const phone = (value) => {
    if (!value || !value.length) {
        return true
    }

    // El teléfono debe contener solo números, espacios, guiones y un signo de "+" al principio opcional
    if (!/^[+]?[0-9\s-]+$/.test(value)) {
        return 'El teléfono debe contener solo números, espacios y guiones';
    }

    return true;
}

/**
 * Valida que el valor sea un campo válido de semestre
 */
export const semester = value => {

    if (!value) {
        return true;
    }

    const parts = value.split('-');

    // Si la primera parte no es un año, no es válido
    if (!/^\d+$/.test(parts[0])) {
        return "El semestre debe tener un año";
    }

    // Si la primera parte no son 4 digitos, no es válido
    if (parts[0].length !== 4) {
        return "El semestre debe tener un año de 4 digitos";
    }

    // Si no tiene guión, no es válido
    if (!value.includes('-')) {
        return "El semestre debe tener un guión";
    }

    // Si la segunda parte no es 1 o 2, no es válido
    if (!/^(1|2)$/.test(parts[1])) {
        return "El semestre debe ser 1 o 2";
    }

    // Si el string completo no tiene 6 caracteres, no es válido
    if (value.length !== 6) {
        return "El semestre debe tener 6 caracteres";
    }

    return true;
}

export const url = (value) => {
    if (!value || !value.length) {
        return true
    }

    return /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w.-]*)*\/?$/.test(value) || 'Ingresa una URL válida';
}

const pages = value => {
    if (!value) return true;

    const singleNumber = /^\d+$/;
    const range = /^(\d+)-(\d+)$/;

    if (singleNumber.test(value)) {
        const num = parseInt(value, 10);
        return num > 0 || 'El número debe ser mayor a 0';
    }

    const match = value.match(range);
    if (match) {
        const start = parseInt(match[1], 10);
        const end = parseInt(match[2], 10);

        if (start <= 0 || end <= 0) return 'Ambos números deben ser mayores a 0';
        if (start > end) return 'El primer número debe ser menor o igual al segundo';

        return true;
    }

    return 'Debe ingresar un número o un rango válido (ej. 10-20)';
};

export const rules = {
    alphabetical,
    alphanumeric,
    between,
    curp,
    email,
    fileSize,
    greaterOrEqualsThan,
    image,
    length,
    max,
    maxLength,
    min,
    minLength,
    numeric,
    pages,
    password,
    period,
    phone,
    positiveInteger,
    required,
    rfc,
    spaces,
    semester,
    text,
    url
}